import type { SearchFilterRequest } from './search-filter-request.type';

export interface SearchRequest {
  orderBy: string | null;
  orderIsAscending: boolean | null;
  searchTerm: string | null;
  entityType: string | null;
  filters: SearchFilterRequest[] | null;
  pageIndex: number;
  pageSize: number;
  includeTotalCount: boolean;
  includeFacets: boolean;
  useFuzzySearch: boolean;
  defaultFilterMode: number | null;
  defaultSearchMode: number | null;
  queryStrategy: number | null;
  sessionId: string | null;
  requestId: string | null;
}

export const searchRequestFactory = (
  request: Partial<SearchRequest>,
): SearchRequest => ({
  searchTerm: request.searchTerm ?? null,
  entityType: request.entityType ?? 'all',
  filters: request.filters ?? [],
  pageIndex: request.pageIndex ?? 1,
  pageSize: request.pageSize ?? 15,
  includeTotalCount: request.includeTotalCount ?? true,
  includeFacets: request.includeFacets ?? true,
  useFuzzySearch: request.useFuzzySearch ?? false,
  defaultFilterMode: request.defaultFilterMode ?? 0,
  defaultSearchMode: request.defaultSearchMode ?? 0,
  queryStrategy: request.queryStrategy ?? 0,
  sessionId: request.sessionId ?? null,
  requestId: request.requestId ?? null,
  orderBy: request.orderBy ?? null,
  orderIsAscending: request.orderIsAscending ?? false,
});
